export enum EMPLOYMENT_STATUS {
	EMPLOYED = "EMPLOYED",
	UNEMPLOYED = "UNEMPLOYED",
	SELF_EMPLOYED = "SELF-EMPLOYED",
}
